import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../../utils/styles';
import Button from '../../Button';
import "./Confirmation.css";
import ConfirmationTicketsInfo from './ConfirmationTicketsInfo';
import ConfirmationCandybarInfo from './ConfirmationCandybarInfo';
import ConfirmationPaymentInfo from './ConfirmationPaymentInfo';
import ConfirmationTicketsHead from './ConfirmationTicketsHead';
import ConfirmationCandybarHead from './ConfirmationCandybarHead';
import ConfirmationContainer from './ConfirmationContainer';

const Info = styled.div`
    @media screen and (min-width: ${breakpoints.desktop}px) {
        border: 1px solid var(--local-text-primary);
        font-size: ${(14/16.8).toFixed(2)}rem;
        padding: var(--pad-y) 3rem;
    }
`;

const Messages = styled.div`
    font-size: 0.9em;
    line-height: 1.35;
`;

const ExtraButtons = styled.div`
    margin: 1.5rem 0 2rem;
    text-align: center;
`;

interface Props {
    bookingPdfUrl?: string;
    data: any;
}

class Confirmation extends React.PureComponent<Props> {
    render() {
        const { data, bookingPdfUrl } = this.props;

        if (!data) {
            return '';
        }

        return <ConfirmationContainer movie={data.movie}>
            {('movie' in data)
                ? <ConfirmationTicketsHead data={data} bookingPdfUrl={bookingPdfUrl} />
                : <ConfirmationCandybarHead data={data} />}

            <Info>
                {('movie' in data) && <ConfirmationTicketsInfo data={data} />}
                <div className="confirmation-info-block">
                    <p className="confirmation-info-row order-number">
                        <span className="confirmation-info-label">Código de compra</span>
                        <span>{data.confirmation_code}</span>
                    </p>
                </div>
                <ConfirmationCandybarInfo data={data.candybar} />
                <ConfirmationPaymentInfo data={data} />
            </Info>

            {data.messages && data.messages.length ? (
                <div className="row">
                    <Messages className="col-12 mt-3">
                        {data.messages.map(m => <React.Fragment>{m}<br /></React.Fragment>)}
                    </Messages>
                </div>
            ) : ''}

            {data.extra_buttons && data.extra_buttons.length > 0 && (
                <ExtraButtons>
                    {data.extra_buttons.map(b => <Button href={b.url} transparent small className="mr-3" target='_blank'>{b.label}</Button>)}
                </ExtraButtons>
            )}
        </ConfirmationContainer>;
    }
}

export default Confirmation;